"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LoadProgressBar_exports = {};
__export(LoadProgressBar_exports, {
  LoadProgressBar: () => LoadProgressBar
});
module.exports = __toCommonJS(LoadProgressBar_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_react_native = require("react-native");
var import_imperative_api = require("../router/imperative-api");
var LoadProgressBar = function(param) {
  var { startDelay = 500, finishDelay = 50, initialPercent = 20, updateInterval = 300, sporadicness = 3, ...props } = param;
  var [loaded, setLoaded] = (0, import_react.useState)(0);
  var [width, setWidth] = (0, import_react.useState)(0);
  (0, import_react.useEffect)(function() {
    var loadInterval;
    var dispose = import_imperative_api.router.onLoadState(function(state) {
      clearTimeout(loadInterval);
      switch (state) {
        case "loading": {
          loadInterval = setTimeout(function() {
            setLoaded(initialPercent);
            var intervalCount = 0;
            loadInterval = setInterval(function() {
              intervalCount++;
              if (intervalCount % sporadicness === 0) {
                return;
              }
              setLoaded(function(prev) {
                var increment = (100 - prev) * (prev > 80 ? 0.05 : 0.1) * Math.random();
                return Math.min(prev + increment, 100);
              });
            }, updateInterval);
          }, startDelay);
          break;
        }
        case "loaded": {
          setLoaded(100);
          clearInterval(loadInterval);
          setTimeout(function() {
            setLoaded(0);
          }, finishDelay);
          break;
        }
      }
    });
    return function() {
      dispose();
      clearInterval(loadInterval);
    };
  }, [
    finishDelay,
    initialPercent,
    sporadicness,
    startDelay,
    updateInterval
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.View, {
    ...props,
    onLayout: function(e) {
      var _props_onLayout;
      setWidth(e.nativeEvent.layout.width);
      (_props_onLayout = props.onLayout) === null || _props_onLayout === void 0 ? void 0 : _props_onLayout.call(props, e);
    },
    style: [
      {
        display: loaded === 0 ? "none" : "flex",
        height: 1,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(60, 100, 200, 0.65)",
        width: "100%",
        transform: [
          {
            translateX: -(1 - loaded * 0.01) * width
          }
        ],
        zIndex: Number.MAX_SAFE_INTEGER
      },
      props.style
    ]
  });
};
//# sourceMappingURL=LoadProgressBar.js.map
